import { put, select } from "redux-saga/effects";
import { API } from 'aws-amplify';
import { getResponseData } from '../../utils/apiHelpers';
import moment from "moment";

import * as actions from "../actions";
import * as selectors from "../selectors/selectors";
import { handleApiError } from '../../utils/apiErrorHandler';

const kryGrondvog = async (params) => {
    let apiName = 'AWSApiGateway';
    let path = `/grondvog${params ? "?" + params.join("&") : "?aantaldae=7"}`;
    const response = await API.get(apiName, path, { response: true });
    // console.log(response);
    var lesings = [...getResponseData(response, [])];
    for (var lesing of lesings) {
        lesing.value = lesing.gradering;
        lesing.coordinates = { lat: lesing.lat, lng: lesing.lon };
        lesing.date = lesing.datumtyd;
        lesing.capturer = lesing.arbeider.naam;
        delete lesing.lat;
        delete lesing.lon;
        delete lesing.gradering;
        delete lesing.arbeider;
        delete lesing.akkuraatheid;
    }
    // console.log(lesings);
    return lesings;
}

const kryOnkruid = async (params) => {
    try {
        let apiName = 'API_Aktiwiteite';
        let path = `/onkruidverkenning${params ? "?" + params.join("&") : "?aantaldae=7"}`;
        const response = await API.get(apiName, path, { response: true });
        // console.log(response);
        var lesings = [...getResponseData(response, [])];
        for (var lesing of lesings) {
            lesing.value = lesing.waarde;
            lesing.coordinates = lesing.posisie;
            lesing.date = lesing.datumtyd;
            lesing.capturer = lesing.werknemer.naam;
            delete lesing.waarde;
            delete lesing.posisie;
            delete lesing.datumtyd;
            delete lesing.werknemer;
        }
        return lesings;
    } catch (error) {
        console.log(error);
        console.log(handleApiError(error, { context: 'saga' }));
        throw error;
    }
}

const kryLegacyLayers = async (params) => {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/layers/aktiwiteite?aktiwiteittipe=legacy`;
        const response = await API.get(apiName, path, { response: true });
        // console.log(response);
        let data;
        if (response.status === 204) {
            data = [];
        } else {
            data = getResponseData(response, []);
        }
        return data;
    } catch (error) {
        console.log(error);
        console.log(handleApiError(error, { context: 'saga' }));
        throw error;
    }
}

export function* getLayerslysSaga_legacy(action) {
    try {
        var layers = yield kryLegacyLayers();
        yield put(actions.setLayerslys_legacy(layers));
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.getLayerslysFailed_legacy(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}

export function* kiesLayerSaga_legacy(action) {
    try {
        const aktiewelayers = yield select(selectors.layersAkief_legacy);
        console.log(aktiewelayers, action.key);
        var lesings;
        if (aktiewelayers.indexOf(action.key) > -1) {
            if (action.key === 1) {
                lesings = yield kryGrondvog();
            }
            if (action.key === 3) {
                lesings = yield kryOnkruid();
            }
            yield put(actions.setLayers_legacy({ id: action.key, data: lesings }));
        } else {
            yield put(actions.removeLayer_legacy(action.key));
        }
    } catch (error) {
        console.log(error);
    }
}

export function* veranderLayerFilterSaga_legacy(action) {
    try {
        const aktiewelayers = yield select(selectors.layersAkief_legacy);
        var params = [];
        var lesings;
        if (aktiewelayers.indexOf(action.key) > -1) {
            if (action.tipe === "daterange") {
                params.push("begindatum=" + moment(action.nuwewaarde[0]).endOf("day").format("Y-MM-DD HH:mm:ss"));
                params.push("einddatum=" + moment(action.nuwewaarde[1]).endOf("day").format("Y-MM-DD HH:mm:ss"));
            }
            if (action.key === 1) {
                lesings = yield kryGrondvog(params);
            }
            if (action.key === 3) {
                lesings = yield kryOnkruid(params);
            }
            yield put(actions.setLayers_legacy({ id: action.key, data: lesings }));
        } else {
            yield put(actions.removeLayer_legacy(action.key));
        }
    } catch (error) {
        console.log(error);
    }
}